import { Contact } from './Contact'
import { Address } from './Address';



export class Guest {
    constructor() {
        this.name = ""
        this.nic_number=null,
        this.passport_number=null,
        this.addresses = [new Address()],
        this.contacts = [new Contact()]
   
        
    }

    toRequest(u) {
        
        var data = {}
        data.id = u.id,
        data.name = u.name ,
        data.nic_number = u.nic_number,
        data.passport_number = u.passport_number,
        data.address = u.address,
        data.phone = u.phone,
        data.email = u.email,
        data.company = u.company,
        data.date_of_birth = u.date_of_birth?u.date_of_birth:null


        return data
    }
    toViewModal(u){
        
        let customer= new Object();
        customer.id = u.id ? u.id : '';
        customer.name = u.name ? u.name : '';
        customer.nic_number=u.nic_number?u.nic_number:'';
        customer.passport_number = u.passport_number? u.passport_number:'';
        customer.address = u.address && u.address?u.address:'';
        customer.is_active = u.is_active;
        customer.phone = u.phone?  u.phone :'';
        customer.email = u.email ?  u.email :'';
        customer.company = u.company?  u.company :'';
        customer.date_of_birth = u.date_of_birth ?  u.date_of_birth :'';
        customer.image = u.image?u.image:''
        return customer
   
    }
    //get Api data and Deserialise the data
    Initialise(initialiser) {
        
        const data = new Guest();
        data.name = initialiser.name ? initialiser.name : ''
        data.id = initialiser.id ? initialiser.id : ''
        data.passport_number = initialiser.passport_number ? initialiser.passport_number : ''
        data.nic_number = initialiser.nic_number ? initialiser.nic_number : ''
        data.address = initialiser.address ? initialiser.address : ''
        data.phone = initialiser.phone ? initialiser.phone : ''
        data.email = initialiser.email ? initialiser.email : ''
        data.company = initialiser.company ? initialiser.company : ''
        data.date_of_birth = initialiser.date_of_birth ? initialiser.date_of_birth : ''
       data.image = initialiser.image?initialiser.image:""
        return data
    }
   
  


}